import urlJoin from 'url-join';

const generatePMFSurveyLink = (link, userId, locale) =>
  urlJoin(link, `?u=${userId}`, `&l=${locale}`);

export default generatePMFSurveyLink;
